import { t as localeText } from "@/shared/lib/translate";
import { useQuery } from "@tanstack/react-query";
import { api } from "./client";
import type { components } from "./contract";
import { unwrap } from "./errors";
import { queryKeys } from "./query-keys";

type Asset = components["schemas"]["V2Asset"];

/** One shared, paginated image index for cards and the editor, scoped by workspace. */
export async function listImageEditAssets(spaceID: string, signal?: AbortSignal): Promise<Asset[]> {
  const assets = new Map<string, Asset>();
  const seen = new Set<string>();
  let cursor: string | undefined;
  do {
    const page = unwrap(await api.GET("/v1/assets", {
      params: { query: { media_type: "image", status: "available", integrity_state: "verified", limit: 100, cursor } }, signal,
    }));
    for (const asset of page.items) if (asset.space_id === spaceID) assets.set(asset.id, asset);
    cursor = page.next_cursor || undefined;
    if (cursor && seen.has(cursor)) throw new Error(localeText("interface.edit_history_could_not_finish_loading_please_try_ef3e572f", { defaultValue: "Edit history could not finish loading. Please try again." }));
    if (cursor) seen.add(cursor);
  } while (cursor);
  return [...assets.values()];
}

export function useImageEditAssets(spaceID: string, enabled = true) {
  return useQuery({ queryKey: queryKeys.foundation.imageEdits(spaceID), queryFn: ({ signal }) => listImageEditAssets(spaceID, signal), enabled: enabled && Boolean(spaceID), staleTime: 30_000 });
}
